import Lottie from 'lottie-react'
import { useEffect } from 'react'

import animationDataDark from '@/../public/animations/clayton_zoom.dark.json'
import animationDataLight from '@/../public/animations/clayton_zoom.light.json'
import { useTheme } from '@/hooks/useTheme'

export function SplashScreen(): JSX.Element {
  const { currentTheme } = useTheme()

  useEffect(() => {
    if (currentTheme === 'dark') {
      document.getElementById('claytonLoader').style.backgroundColor = '#141414'
    }
    // Runs ONCE after initial rendering only when the component mounts.
  }, [currentTheme])

  return (
    <div
      id="claytonLoader"
      style={{
        alignItems: 'center',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
      }}
    >
      <Lottie
        animationData={
          currentTheme === 'dark' ? animationDataDark : animationDataLight
        }
        style={{ width: '256px', height: '256px' }}
        data-cy="loader"
        alt="loader"
      />
    </div>
  )
}
